<template>
  <div class="accessibility-banner" v-if="accessibilityUrl">
    <a :href="accessibilityUrl" target="_blank" rel="noopener noreferrer" class="accessibility-link">
      Toegankelijkheidsverklaring
    </a>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'accessibility-banner',
  computed: {
    ...mapGetters([
      'getAccessibilityStatementUrl'
    ]),
    accessibilityUrl() {
      if (this.getAccessibilityStatementUrl && this.getAccessibilityStatementUrl) {
        return this.getAccessibilityStatementUrl
      }
      return null
    }
  }
}
</script>

<style scoped>
.accessibility-banner {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
}

.accessibility-link {
  display: inline-block;
  padding: 10px 16px;
  background-color: #4a4a4a;
  color: white;
  text-decoration: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.accessibility-link:hover {
  background-color: #2d2d2d;
  text-decoration: none;
  color: white;
}

.accessibility-link:focus {
  outline: 2px solid #2d2d2d;
  outline-offset: 2px;
}

@media (max-width: 576px) {
  .accessibility-banner {
    bottom: 10px;
    right: 10px;
  }

  .accessibility-link {
    padding: 8px 12px;
    font-size: 12px;
  }
}
</style>

